var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "38.132px",
    height: "63.504px",
    viewBox: "0 0 38.132 63.504",
    enableBackground: "new 0 0 38.132 63.504",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard-66") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Left"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#32B2F9",
    d: "M1.938,61.648c-2.477-2.477-2.478-6.492-0.001-8.97l20.886-20.886L1.936,10.905 c-0.052-0.051-0.104-0.103-0.155-0.156c-2.434-2.52-2.364-6.535,0.155-8.969c2.52-2.434,6.536-2.364,8.968,0.156l25.372,25.371 c2.476,2.478,2.476,6.491,0,8.969l-25.372,25.37c-1.189,1.189-2.802,1.857-4.483,1.857S3.127,62.838,1.938,61.648z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderRightArrow);
export default __webpack_public_path__ + "static/media/slider-right-arrow.f4550551517cc512db0c6b0577accd12.svg";
export { ForwardRef as ReactComponent };